import * as React from 'react'
import { customerMarketShopfrontApi } from '@envato/foundation-types'
import get from 'lodash-es/get'

import filterParamsConfig from '../../../../common/constants/filterParamsConfig'
import SearchLinkContainer from '../../../containers/searchLinkContainer'
import { IBlockMatchedComponent } from '../../../pages/category/category'
import * as styles from './textSearchFiltersBlock.module.css'

interface IFilterGroup {
  title: string
  aggregationId?: string
  options: customerMarketShopfrontApi.categoryPage.ISearchCta[]
}

interface IProps extends IBlockMatchedComponent {
  data: IFilterGroup[]
}

const aggregationsToHumanise = ['files_included']

const humaniseTitle = (title: string, aggregationId?: string) => {
  const customLabelsForAggregation =
    aggregationId &&
    aggregationsToHumanise.includes(aggregationId) &&
    get(filterParamsConfig, `${aggregationId}.labels`)
  if (customLabelsForAggregation) {
    return customLabelsForAggregation[title]
  } else {
    return title
  }
}

const TextSearchFiltersBlock = ({ data }: IProps) => (
  <section className={styles.root}>
    <div className={styles.inner}>
      {data.map(filterGroup => (
        <div className={styles.filterGroup} key={filterGroup.title}>
          <h3 className={styles.filterGroupHeading}>{filterGroup.title}</h3>
          {filterGroup.options.map(({ title, urlSearchParams }) => (
            <SearchLinkContainer
              className={styles.option}
              key={title}
              locationParams={urlSearchParams}
            >
              {humaniseTitle(title, filterGroup.aggregationId)}
            </SearchLinkContainer>
          ))}
        </div>
      ))}
    </div>
  </section>
)

export default TextSearchFiltersBlock
